import { Box, Container, Divider, Paper, Typography } from "@mui/material";
import { useRouteError } from "react-router-dom";

const ErrorElement = () => {
  const error = useRouteError();

  return (
    <Box
      sx={{
        bgcolor: "background.default",
        height: "100dvh",
        pt: 5,
      }}
    >
      <Container
        maxWidth="sm"
        sx={{
          width: "fit-content",
          borderRadius: 2,
          p: 2,
          m: "auto",
          textAlign: "center",
        }}
        component={Paper}
      >
        <Typography fontSize={24}>از مشکل پیش آمده، عذر میخواهیم.</Typography>
        <Typography mb={2} mt={1}>
          لطفاً صفحه را رفرش کنید، یا مشکل را گزارش کنید.
        </Typography>

        <Divider />

        <Typography mt={2} color="error.main">
          {error.statusText || error.message}
        </Typography>
      </Container>
    </Box>
  );
};

export default ErrorElement;
